/**
 * The shape of an app service-ticket id: `S` + 6 digits or `STR` + 4 digits,
 * optionally `-` + letters/digits/dashes (S260926-KJZ, S240710-F32-D7, STR0123).
 * Shared by global search (typesense-service) and by the error reporter's
 * form-id tags (forms/activeFormContext), so "what counts as a ticket id" has
 * one definition.
 */
export const SERVICE_ID_PATTERN = /^(?:S\d{6}(?:-[a-z0-9-]*)?|STR\d{4}(?:-[a-z0-9]*)?)$/i;
